export class HttpConstants {
    constructor() {
    }
}

export namespace HttpConstants {
    export const NEWTORK_ERROR = 'Network error';
}
